import {useUserData} from '@frontend/hooks'
import {useWebPushSubscription} from 'swayok-react-mdb-ui-kit/helpers/useWebPushSubscription'
import {AnalyticsEventReporter} from '../../helpers/AnalyticsEventReporter'

// Регистрация скрипта Service Worker и контроль подписки на Web PUSH уведомления.
export function GlobalWebPushSubscriptionHandler() {

    useWebPushSubscription(useUserData()?.id, {
        onSubscriptionDecision(userId, granted) {
            AnalyticsEventReporter.pushNotificationsPermissionRequested(true)
            AnalyticsEventReporter.pushNotificationsPermissionDecision(userId, granted)
        },
        onServiceWorkerError() {
            AnalyticsEventReporter.pushNotificationsPermissionRequested(
                false,
                'Failed to install Service Worker'
            )
        },
    })

    return null
}
